import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdDirective } from './directives/ad.directive';
import { CheckShortDateDirective } from './directives/check-short-date.directive';
import { HasAccessDirective } from './directives/has-access.directive';
import { LinkDirective } from './directives/link.directive';
import { SelectClickableDirective } from './directives/select-clickable.directive';
import { TestIdDirective } from './directives/test-id.directive';
import { AddSpaceBetweenCharPipe } from './pipes/add-space-between-char.pipe';
import { CheckValueNaPipe } from './pipes/check-value-na.pipe';
import { ConvertDimensionsPipe } from './pipes/convert-dimensions.pipe';
import { ConvertSecondsToMinutesPipe } from './pipes/convert-seconds-to-minutes.pipe';
import { ConvertWeightPipe } from './pipes/convert-weight.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { FormControlPipe } from './pipes/form-control.pipe';
import { PriceFormatPipe } from './pipes/price-format.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { StringReplacePipe } from './pipes/string-replace.pipe';
import { TextWrapPipe } from './pipes/text-wrap.pipe';
import { TranslateProductOrientationPipe } from './pipes/translate-product-orientation.pipe';
import { UpperFirstLetterPipe } from './pipes/upper-first-letter.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    LinkDirective,
    SelectClickableDirective,
    StringReplacePipe,
    HasAccessDirective,
    TextWrapPipe,
    CheckValueNaPipe,
    DateFormatPipe,
    UpperFirstLetterPipe,
    AdDirective,
    CheckShortDateDirective,
    SearchPipe,
    PriceFormatPipe,
    ConvertSecondsToMinutesPipe,
    FormControlPipe,
    ConvertWeightPipe,
    AddSpaceBetweenCharPipe,
    TestIdDirective,
    ConvertDimensionsPipe,
    TranslateProductOrientationPipe,
  ],
  exports: [
    LinkDirective,
    SelectClickableDirective,
    StringReplacePipe,
    HasAccessDirective,
    TextWrapPipe,
    CheckValueNaPipe,
    DateFormatPipe,
    UpperFirstLetterPipe,
    AdDirective,
    CheckShortDateDirective,
    SearchPipe,
    PriceFormatPipe,
    ConvertSecondsToMinutesPipe,
    ConvertWeightPipe,
    AddSpaceBetweenCharPipe,
    TestIdDirective,
    ConvertDimensionsPipe,
    TranslateProductOrientationPipe,
  ],
})
export class CoreModule {}
